/**
 * Utilitaires pour gérer les opérations de confirmation et de suppression
 */

/**
 * Configuration d'une confirmation générique
 * @param {Object} item - L'élément concerné par la confirmation
 * @param {string} itemType - Le type d'élément (ex: 'classe', 'élève', etc.)
 * @param {string} nameField - Le champ à utiliser comme nom (ex: 'libelle', 'nom', etc.)
 * @param {string} action - L'action à confirmer (ex: 'supprimer', 'archiver', etc.)
 * @returns {Object} Configuration pour le composant ConfirmationModal
 */
export const getDeleteConfirmation = (item, itemType = 'élément', nameField = 'libelle', action = 'supprimer') => {
  if (!item) return {};
  
  const itemName = item[nameField] || 'cet élément';
  const capitalizedItemType = itemType.charAt(0).toUpperCase() + itemType.slice(1);
  
  return {
    title: `${action.charAt(0).toUpperCase() + action.slice(1)} ${itemType}`,
    message: `Êtes-vous sûr de vouloir ${action} ${itemType === 'la classe' ? 'la' : 'le'} ${itemType} "${itemName}" ? Cette action est irréversible.`,
    confirmText: capitalizedItemType === action ? `${capitalizedItemType}` : `${action.charAt(0).toUpperCase() + action.slice(1)}`,
    type: 'danger'
  };
};

/**
 * Configuration d'une confirmation de validation/approbation
 * @param {Object} item - L'élément concerné par la confirmation
 * @param {string} itemType - Le type d'élément (ex: 'demande', 'inscription', etc.)
 * @param {string} nameField - Le champ à utiliser comme nom (ex: 'numero', 'reference', etc.)
 * @returns {Object} Configuration pour le composant ConfirmationModal
 */
export const getApprovalConfirmation = (item, itemType = 'élément', nameField = 'reference') => {
  if (!item) return {};
  
  const itemName = item[nameField] || 'cet élément';
  
  return {
    title: `Valider ${itemType}`,
    message: `Confirmez-vous la validation ${itemType === 'la demande' ? 'de la' : 'du'} ${itemType} "${itemName}" ?`,
    confirmText: 'Valider',
    type: 'info'
  };
}; 